import { Pipe, PipeTransform } from '@angular/core';

export function convertSecondsToTimeUnit(seconds: number, options: { showPlusMinus?: boolean; compact?: boolean } = {}): string {
    const { showPlusMinus = false, compact = false } = options;
    const absSeconds = Math.abs(seconds);
    const hours = Math.floor(absSeconds / 3600);
    const minutes = Math.floor((absSeconds % 3600) / 60);

    const sign = showPlusMinus ? (seconds < 0 ? '-' : '+') : '';

    if (compact) {
        const hoursStr = hours ? `${hours}h` : '';
        const minutesStr = minutes ? `${minutes}m` : '';
        return `${sign} ${hoursStr}${minutesStr}`.trim();
    }

    const hoursStr = hours ? `${hours} hr${hours > 1 ? '(s)' : ''}` : '';
    const minutesStr = minutes ? `${minutes} min` : (hours ? '' : '0 min');
    const andStr = hours && minutes ? ' and ' : '';

    return `${sign} ${hoursStr}${andStr}${minutesStr}`.trim();
}

@Pipe({
  name: 'secondsToTimeUnit'
})
// Get the seconds and display hours and minutes
export class SecondsToTimeUnitPipe implements PipeTransform {
  transform(seconds: number, showPlusMinus: boolean = false, compact: boolean = false): string {
    return convertSecondsToTimeUnit(seconds, { showPlusMinus, compact });
  }

}
